<div class="w-100">
    <mwp-card-content-header [url]="apiUrl" />
    <mwp-table [tableColumns]="dependentColumns" [dataSource]="dependentMatTableData" (emitButtonSelection)="openDialog($event)" header="Dependent List" />
</div>